// (A) 중립 버튼 API — antd 미접촉. (B) PlainButton(플레인) 에 위임.
import type { CSSProperties, MouseEvent, ReactNode } from 'react'
import { PlainButton } from '../_impl/PlainButton'

export interface OmwButtonProps {
  variant?: 'primary' | 'default' | 'text' | 'link'
  size?: 'sm' | 'md' | 'lg'
  disabled?: boolean
  loading?: boolean
  block?: boolean
  danger?: boolean
  /**
   * color=primary(파랑) 적용. antd Button 의 `color="primary"` 파리티 — 지정 시에만
   * om-btn-color-primary 를 부여해 solid 외 variant(text/outlined/link)의 텍스트를 #1677ff 로 만든다.
   * danger 와 동시 지정 시 danger 가 우선.
   */
  primary?: boolean
  htmlType?: 'button' | 'submit' | 'reset'
  /** 아이콘 슬롯. ReactNode 로 노출. */
  icon?: ReactNode
  /** 아이콘 위치. */
  iconPosition?: 'start' | 'end'
  /** 기존 스타일 유지에 필수. */
  className?: string
  style?: CSSProperties
  /**
   * ⚠ event 를 그대로 전달한다. 기존 소비처가 e.stopPropagation()/preventDefault() 를
   * 쓰므로 event 를 숨기면 회귀.
   */
  onClick?: (e: MouseEvent<HTMLElement>) => void
  children?: ReactNode
  'data-testid'?: string
  /** 네이티브 title 툴팁. */
  title?: string
  /** a11y 라벨. */
  'aria-label'?: string
}

export function OmwButton(props: OmwButtonProps) {
  return <PlainButton {...props} />
}
